export function getdata() {
	var obj = {
		headDataI: [{
				title: "操作",
				prop: "cz",
				width: "150px",
				custom: true,
			},
			{
				title: "应税消费品名称",
				prop: "xfs_4_x_1.1",
				width: "150px",
				custom: true,
			},
			{
				title: "商品和服务税收分类编码",
				prop: "xfs_4_x_2",
				width: "150px",
				custom: true,
			},
			{
				title: "委托加工收回应税消费品数量",
				prop: "xfs_4_x_3",
				width: "150px",
				custom: true,
			},
			{
				title: "委托加工回收应税消费品计税价格",
				prop: "xfs_4_x_4",
				width: "150px",
				custom: true,
			},
			{
				title: "一、本期准予扣除的委托加工应税消费品已纳税款计算",
				children: [{
						title: "定额税率",
						prop: "xfs_4_x_5",
						width: "150px",
						custom: true,
					},
					{
						title: "比例税率",
						prop: "xfs_4_x_6",
						width: "150px",
						custom: true,
					},
				]
			},
			{
				title: "受托方已代收代缴的税款",
				prop: "xfs_4_x_7",
				width: "150px",
				custom: true,
			}, {
				title: "受托方(扣缴义务人)跨省行政区划",
				prop: "xfs_4_x_8",
				width: "150px",
				custom: true,
			}, {
				title: "受托方(扣缴义务人)名称",
				prop: "xfs_4_x_9",
				width: "150px",
				custom: true,
			}, {
				title: "受托方(扣缴义务人)识别号",
				prop: "xfs_4_x_10",
				width: "150px",
				custom: true,
			}, {
				title: "税收缴款书（代扣代收专用）号码",
				prop: "xfs_4_x_11",
				width: "150px",
				custom: true,
			}, {
				title: "税收缴款书（代扣代收专用）开具日期",
				prop: "xfs_4_x_12",
				width: "150px",
				custom: true,
			},
		],

		tableDataI: [{
				disablednoty_0_x_tes1: false,
				disablednoty_0_x_tes2: false,
				disablednoty_0_x_tes3: false,
				disablednoty_0_x_tes4: false,
				disablednoty_0_x_tes5: false,
				disablednoty_0_x_tes6: false,
				disablednoty_0_x_tes7: false,
				disablednoty_0_x_tes8: false,
				disablednoty_0_x_tes9: false,
				disablednoty_0_x_tes10: false,
				disablednoty_0_x_tes11: false,
				disablednoty_0_x_tes12: false,
				tes1: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes2: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes3: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes4: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes5: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes6: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes7: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes8: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes9: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes10: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes11: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes12: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},

			},
			{
				disablednoty_0_x_tes1: false,
				disablednoty_0_x_tes2: false,
				disablednoty_0_x_tes3: false,
				disablednoty_0_x_tes4: false,
				disablednoty_0_x_tes5: false,
				disablednoty_0_x_tes6: false,
				disablednoty_0_x_tes7: false,
				disablednoty_0_x_tes8: false,
				disablednoty_0_x_tes9: false,
				disablednoty_0_x_tes10: false,
				disablednoty_0_x_tes11: false,
				disablednoty_0_x_tes12: false,
				tes1: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes2: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes3: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes4: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes5: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes6: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes7: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes8: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes9: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes10: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes11: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes12: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},

			},
		],




		headDataII: [{
				title: "操作",
				prop: "cz",
				width: "150px",
				custom: true,
			},
			{
				title: "应税消费品名称",
				prop: "xfs_4_x_1.1",
				width: "150px",
				custom: true,
			},
			{
				title: "商品和服务税收分类编码",
				prop: "xfs_4_x_2",
				width: "150px",
				custom: true,
			},
			{
				title: "上期库存数量",
				prop: "xfs_4_x_3",
				width: "150px",
				custom: true,
			},
			{
				title: "本期委托加工收回入库数量",
				prop: "xfs_4_x_4",
				width: "150px",
				custom: true,
			},
			{
				title: "本期委托加工收回直接销售数量",
				prop: "xfs_4_x_5",
				width: "150px",
				custom: true,
			},
			{
				title: "本期委托加工收回用于连续生产数量",
				prop: "xfs_4_x_6",
				width: "150px",
				custom: true,
			},
			{
				title: "本期结存数量",
				prop: "xfs_4_x_7",
				width: "150px",
				custom: true,
			}
		],

		tableDataII: [{
				disablednoty_0_x_tes1: false,
				disablednoty_0_x_tes2: false,
				disablednoty_0_x_tes3: false,
				disablednoty_0_x_tes4: false,
				disablednoty_0_x_tes5: false,
				disablednoty_0_x_tes6: false,
				disablednoty_0_x_tes7: false,
				tes1: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes2: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes3: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes4: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes5: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes6: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes7: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
			},
			{
				disablednoty_0_x_tes1: false,
				disablednoty_0_x_tes2: false,
				disablednoty_0_x_tes3: false,
				disablednoty_0_x_tes4: false,
				disablednoty_0_x_tes5: false,
				disablednoty_0_x_tes6: false,
				disablednoty_0_x_tes7: false,
				tes1: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes2: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes3: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes4: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes5: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes6: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				tes7: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
			},
		],
	}
	return obj
}